import { createSelector } from 'reselect'

export const selectTotalBalance = (state) => state.appReducer.user?.userData?.totalBalance || 0
export const selectClosedPnl = (state) => state.appReducer.user?.userData?.closedTotalPnl || 0
export const selectBonusBalance = (state) => state.appReducer.user?.userData?.bonusBalance || 0
export const selectCashBalance = (state) => state.appReducer.user?.userData?.cashBalance || 0
export const selectUserId = (state) => state.appReducer.user?.userData?.id || ''
export const selectComplexLeverage = (state) => state.appReducer.user?.userData?.complexLeverage
export const selectUserCurrency = (state) => state.appReducer.user?.userData?.currency || 'USD'
export const selectUserTheme = (state) => state.appReducer.user?.userData?.theme || ''
export const selectMarginCallRate = (state) => state.appReducer.user?.userData?.marginCallRate || ''
export const selectRiskData = (state) => state.appReducer.user?.riskData || null
export const selectRiskDataDefault = (state) => state.appReducer.user?.riskDataDefault || null
export const selectPlatformLang = (state) => state.appReducer.user?.userJson?.platform?.lang || 'en'
export const selectLogoUrl = (state) => state.appReducer.user?.userJson?.platform?.logo_url || ''
export const selectLastUsdPrice = (state) => state.appReducer.user?.userJson?.platform?.lastUsdPrice || '1'
export const selectPricerLink = (state) => state.appReducer.user?.userJson?.platform?.pricer?.link
export const selectUserClosedTotalPnl = (state) =>
	state.appReducer.user?.userJson?.platform?.trading?.userClosedTotalPnl
export const selectShowClosedTotalPnl = (state) =>
	state.appReducer.user?.userJson?.platform?.trading?.showClosedPNL
export const selectUserDailyClosedPnl = (state) =>
	state.appReducer.user?.userJson?.platform?.trading?.userDailyClosedPnl
export const selectCurrencySides = (state) => state.appReducer.user?.userJson?.platform?.currencySides
const currencySidesTargets = (state) => state.appReducer.user?.userJson?.platform?.currencySidesTargets
export const selectUserTotalPnl = (state) => state.appReducer.user?.userJson?.platform?.trading?.userTotalPnl
export const selectShowTotalPnl = (state) => state.appReducer.user?.userJson?.platform?.trading?.showPNL
export const selectUserCashBalance = (state) => state.appReducer.user?.userJson?.platform?.trading?.userCashBalance
export const selectShowCashBalance = (state) => state.appReducer.user?.userJson?.platform?.trading?.showCashBalance
export const selectUserBonusBalance = (state) => state.appReducer.user?.userJson?.platform?.trading?.userBonusBalance
export const selectShowBonusBalance = (state) => state.appReducer.user?.userJson?.platform?.trading?.showBonusBalance
export const selectUserTotalBalance = (state) => state.appReducer.user?.userJson?.platform?.trading?.userTotalBalance
export const selectShowBalance = (state) => state.appReducer.user?.userJson?.platform?.trading?.showBalance
export const selectDeltaEquity = (state) => state.appReducer.user?.userJson?.platform?.trading?.deltaEquity
export const selectShowEquityMarginRatio = (state) => state.appReducer.user?.userJson?.platform?.trading?.showEquityMarginRatio
export const selectUserEquity = (state) => state.appReducer.user?.userJson?.platform?.trading?.userEquity
export const selectShowEquity = (state) => state.appReducer.user?.userJson?.platform?.trading?.showEquity
export const selectUseMargin = (state) => state.appReducer.user?.userJson?.platform?.trading?.useMargin
export const selectShowUsedMargin = (state) => state.appReducer.user?.userJson?.platform?.trading?.showUsedMargin
export const selectUserAvailableMargin = (state) =>
	state.appReducer.user?.userJson?.platform?.trading?.userAvailableMargin
export const selectShowAvailableMargin = (state) =>
	state.appReducer.user?.userJson?.platform?.trading?.showAvailableMargin
export const selectShowTradingBar = (state) =>
	state.appReducer.user?.userJson?.platform?.trading?.showTradingBar
export const selectPricerTradingViewPort = (state) => state.appReducer.user?.userJson?.platform?.pricer?.tradingViewPort
export const selectMarginTradePlatform = (state) =>
	state.appReducer.user?.userJson?.platform?.margin_trade_platform || 1
export const selectMinLotCount = (state) =>
	state.appReducer.user?.userJson?.user?.minLotCount || '0.1'
export const selectMaxLotCount = (state) => state.appReducer.user?.userJson?.user?.maxLotCount || '100'
export const selectMessages = (state) => state.appReducer.user?.messages || null

export const selectCurrencySidesTargets = createSelector(
	[
		currencySidesTargets],
	(currencySidesTargets ) => {
		if (!currencySidesTargets) return null
		currencySidesTargets['xxx/EURT'] = [91, 0]
		return currencySidesTargets
	}
)
